export const defaultTransactionFieldsValues = {
  auth: true,
  authsuppresschallenge: false,
  billtoemail: null,
  billtocontactname: null,
  billtostreet1: null,
  billtostreet2: null,
  billtocity: null,
  billtozipcode: null,
  billtocountry: 'BR',
  billtophonenumber: null,
  billtostate: null,
  challengewindowsize: 'FullPage',
  currency: 'BRL',
  installments: 1,
  merchanturl: 'https://www.pagtel.com.br',
  orderproductcode: 'PHY',
  paymentmethod: 'debit',
  shiptoemail: null,
  transactionmode: 'S',
}

export const EventDispatch = {
  READY: "cielo_payment:ready",
  SUCCESS: "cielo_payment:success",
  FAILURE: "cielo_payment:failure",
  UNENROLLED: "cielo_payment:unenrolled",
  DISABLED: "cielo_payment:disabled",
  ERROR: "cielo_payment:error",
  UNSUPPORTED_BRAND: "cielo_payment:unsupported_brand",
}
